import React from 'react';
import I18n from 'common/i18n';
import * as _ from 'lodash';
import { ForgeIconButton, ForgeIcon } from '@tylertech/forge-react';

const t = (key: string, options = {}, scope = 'shared.explore_grid.remove_node') => I18n.t(key, { ...options, scope });
interface Props {
  onClick: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const RemoveNode: React.FC<Props> = ({ onClick, onMouseEnter, onMouseLeave }: Props) => {
  return (
    <div className="remove-node"  onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <ForgeIconButton
        aria-label={t('remove_button_label')}
        data-testid='remove-node-icon-button'
        onClick={onClick}
        onKeyPress={onClick}
      >
        <ForgeIcon name="close" />
      </ForgeIconButton>
    </div>
  );
};

export default RemoveNode;
